export enum Roles {
  SUPER_ADMIN = 'Super Admin',
  GENERAL_ADMIN = 'General Admin',
  CENTER_ADMIN = 'Centre Admin',
  CENTER_USER = 'Centre User',
  CANDIDATE = 'Candidate',
}

export default Roles
